export const apiURL = process.env.REACT_APP_API_URL ?? 'https://api.stream.dromt.it/v1alpha1';
export const graphqlURL = process.env.REACT_APP_GRAPHQL_URI ?? "https://graphql.dromt.it/v1/graphql";
export const version = process.env.REACT_APP_VERSION ?? 'dev';

export const gtmId = process.env.REACT_APP_GTM_ID ?? 'GTM-XXXXXX';
